import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';
import materialsData from '../data/materials.json';
import useScrollTop from '../hooks/useScrollTop';
import PageTransition from '../components/PageTransition';
import { FaIndustry, FaHistory, FaDollarSign } from 'react-icons/fa';

const LandingPage = () => {
  useScrollTop();
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  const handleInquireClick = () => {
    navigate('/contact');
  };

  const handleBrowseClick = () => {
    // Scroll to categories section smoothly
    document.querySelector('.categories').scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };
  return (
    <PageTransition>
      <div className="landing-page">
      <header className="hero">
        <div className="hero-content">
          <div className="logo-container">
            <img src="/images/malik-international-logo.png" alt="Malik International Logo" className="hero-logo" />
          </div>
          <h1>Malik International</h1>
          <p className="subtitle">Premium Foundry Raw Materials</p>
          <p className="description">
            Your trusted supplier of high-quality foundry materials from China to Pakistan
          </p>
          <div className="hero-buttons">
            <button className="inquire-now-btn" onClick={handleInquireClick}>Inquire Now</button>
            <button className="browse-products-btn" onClick={handleBrowseClick}>Browse Products</button>
          </div>
        </div>
      </header>

      <section className="categories">
        <h2>Our Product Categories</h2>
        <div className="categories-grid">
          {materialsData.categories.map((category) => (
            <div key={category.id} className="category-card">
              <div className="category-content">
                <h3>{category.name}</h3>
                <p>{category.description}</p>
                <button 
                  className="view-more" 
                  onClick={() => handleCategoryClick(category.id)}
                >
                  View Products
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="features">
        <h2>Why Choose Us</h2>
        <div className="features-grid">
          <div className="feature">
            <div className="feature-icon">
              <FaIndustry size={40} />
            </div>
            <h3>Direct Import</h3>
            <p>Premium materials sourced directly from Chinese manufacturers</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <FaHistory size={40} />
            </div>
            <h3>33 Years of Service</h3>
            <p>Three decades of trusted experience in foundry materials</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <FaDollarSign size={40} />
            </div>
            <h3>Competitive Rates</h3>
            <p>Best market prices without compromising on quality</p>
          </div>
        </div>
      </section>

      <section className="contact">
        <h2>Contact Us</h2>
        <div className="contact-content">
          <p>Ready to improve your foundry operations?</p>
          <button className="contact-btn" onClick={handleInquireClick}>Get in Touch</button>
        </div>
      </section>
    </div>
    </PageTransition>
  );
};

export default LandingPage;
